/**
 * WebSocket client for real-time notifications.
 * Connects to the backend Socket.IO server for stock alerts and updates.
 */
import { io, Socket } from 'socket.io-client';

const WS_URL = import.meta.env.VITE_API_URL || '';

let socket: Socket | null = null;

export type NotificationType = 'stock_low' | 'stock_out' | 'sale_completed' | 'announcement';

export interface Notification {
  type: NotificationType;
  title: string;
  message: string;
  data?: Record<string, unknown>;
  timestamp: number;
}

type NotificationListener = (notification: Notification) => void;
const listeners: NotificationListener[] = [];

export function connectWebSocket(token: string): void {
  if (socket?.connected) return;

  socket = io(WS_URL, {
    auth: { token },
    transports: ['websocket'],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionAttempts: 10,
  });

  socket.on('connect', () => {
    console.log('[WS] Connected');
  });

  socket.on('notification', (data: Notification) => {
    listeners.forEach(fn => fn(data));
  });

  socket.on('stock_alert', (data: { product_name: string; stock_quantity: number; status: string }) => {
    const notification: Notification = {
      type: data.status === 'esgotado' ? 'stock_out' : 'stock_low',
      title: data.status === 'esgotado' ? 'Produto Esgotado!' : 'Estoque Baixo',
      message: `${data.product_name}: ${data.stock_quantity} unidades restantes`,
      data,
      timestamp: Date.now(),
    };
    listeners.forEach(fn => fn(notification));
  });

  socket.on('disconnect', () => {
    console.log('[WS] Disconnected');
  });
}

export function disconnectWebSocket(): void {
  socket?.disconnect();
  socket = null;
}

export function onNotification(listener: NotificationListener): () => void {
  listeners.push(listener);
  return () => {
    const idx = listeners.indexOf(listener);
    if (idx >= 0) listeners.splice(idx, 1);
  };
}
